let service = function (
	config,
	growl,
	$rootScope,
	$state,
	$auth
) {
	"ngInject";

	var socket;

	this.bind = function(id) {
		socket = new Pusher('90f6c57d3b450aca4ca6', {
			httpHost: config.api,
			authEndpoint: config.api+'/broadcasting/auth',
			cluster: 'eu',
			auth: {
				headers: {
					'Authorization': 'Bearer '+$auth.getToken()
				}
			}
		});
		socket.bind('message', function(e) {
			$rootScope.$broadcast('chat:received', e.message);
			if ($state.current.name !== 'tab.support') {
				growl.info('Count3r: '+e.message.message);
			}
		});
		socket.subscribe('private-chat.'+id);
	};
	
	this.unbind = function() {
		if (socket) {
			socket.unbind('message');
			Object.keys(socket.channels.channels).forEach(function(key) {
				socket.unsubscribe(key);
			});
		}
	};
}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/socket.service.js